import * as React from 'react';
import { DropDownListComponent } from '../DropDownList/DropDownListComponent';
import { ItemList } from '../../types/logbook-type';
import { useLanguageLocale } from '../../hooks/language-locale-hooks';
import { DeviceList } from '../../types/device';
import { useSelector } from 'react-redux';
import { Selectors } from '../../selectors';

export interface Props {
    defaultValue: string;
    callback: (systemId: string) => void;
}

const SystemFilterSelect: React.FunctionComponent<Props> = (props) => {

    const { defaultValue, callback } = props;

    const { t } = useLanguageLocale();
    const asset = useSelector(Selectors.Asset.assets);

    const [systemList, setSystemList] = React.useState<ItemList>([]);

    const systemListLogbook = (list: DeviceList): ItemList => {
        return list?.map((data, system) => {
            return {
                id: data.systemId,
                name: data.systemName,
            };
        });
    };

    const handleChange = (e: string) => {
        callback(e);
    }

    React.useEffect(() => {
        if (!asset.deviceListLoading && asset.deviceListSuccess) {
            setSystemList(systemListLogbook(asset.deviceList.detail));
        } else if (!asset.deviceListLoading && asset.deviceListFail) {
            setSystemList([]);
        }
    }, [asset.deviceListLoading, asset.deviceListSuccess, asset.deviceListFail]); // eslint-disable-line react-hooks/exhaustive-deps

    return (
        <DropDownListComponent
            disabled={asset.deviceListLoading || systemList.length === 0}
            data-testid="asset-system-filter"
            list={systemList}
            value={t('SEARCH.ALL_SYSTEMS')}
            handleSelection={handleChange}
            selected={defaultValue}
            defaultSelection={defaultValue}>
        </DropDownListComponent>
    );
};

export default SystemFilterSelect;
